import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Form, Row, Col, Button, Input } from "antd";
import { Container } from "react-bootstrap";
import { toastError, toastSuccess } from "helpers/toasters";
import { login } from "store/authorization";
import { getAllGenresOnSystem, signinAdmin } from "Network";
import { genresOnSystem } from "store/staticData";
import { updateCurrentPath } from "store/dynamicData";

function SignIn() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const getGenres = () => {
    getAllGenresOnSystem(
      (success) => {
        if (success?.isSuccess) {
          dispatch(genresOnSystem(success.data));
        }
      },
      (fail) => {
        toastError(fail.err_msg);
      }
    );
  };

  function onFinish(values) {
    if (values?.email && values?.password) {
      setLoading(true);
      signinAdmin(
        values,
        (success) => {
          setLoading(false);
          if (success?.isSuccess) {
            toastSuccess("You are logged in successfully");
            const data = {
              ...success?.data,
              isCeo:
                success?.data?.rolesIds?.[0]?._id ===
                "67851bed62b4920923414cd3",
              isCodesManager:
                success?.data?.rolesIds?.[0]?._id ===
                "678673453782bba400ce711e",
            };
            dispatch(login(data));
            dispatch(updateCurrentPath("dashboard"));
            getGenres();
          }
        },
        (fail) => {
          setLoading(false);
          toastError(fail?.data?.err_msg);
        }
      );
    }
  }

  return (
    <section className="sign-in main-section ">
      <Container>
        <div className="title text-center">Sign In</div>
        <Row className="mrg-ys-100">
          <Col
            xs={{ offset: 3, span: 18 }}
            sm={{ offset: 3, span: 18 }}
            md={{ offset: 6, span: 12 }}
          >
            <Form onFinish={onFinish}>
              <Row gutter={[0, 8]}>
                <Col span={24}>
                  <Form.Item
                    name="email"
                    placeholder="Email"
                    rules={[
                      { required: true, message: "Please, enter your email" },
                      {
                        type: "email",
                        message: "Please provide valid email",
                      },
                    ]}
                  >
                    <Input className={"form-item"} placeholder="Email" />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please, enter your password",
                      },
                    ]}
                  >
                    <Input.Password
                      className={"form-item"}
                      placeholder="Password"
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={{ offset: 3, span: 18 }}
                  sm={{ offset: 3, span: 18 }}
                  md={{ offset: 5, span: 14 }}
                >
                  <Button
                    loading={loading}
                    className="btn-login button-primary "
                    htmlType="submit"
                  >
                    Sign In
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SignIn;
